import {
  SectionElement,
  FormPostSubmitType,
  FieldType,
  ButtonActionType,
} from "@wuilt/section-preview";
import { nanoid } from "nanoid";
import { FormSettingsExtended, OldFormValue } from "./form-types";

const FIELDS_TYPES_MAPPER = {
  Text: FieldType.Text,
  Email: FieldType.Email,
  Phone: FieldType.Phone,
  MultiLineText: FieldType.TextArea,
};

function migrateSettings(old: OldFormValue | FormSettingsExtended) {
  // @ts-ignore has been migrated before
  if (old?.form_data?.formButton) return old.form_data as FormSettingsExtended;
  if ((old as FormSettingsExtended)?.texts) return old as FormSettingsExtended;

  const castedOld = old as OldFormValue;

  const texts = {};
  function injectAndExtractTexts(content: string) {
    const textId = `Content:${nanoid()}`;
    Object.assign(texts, { [textId]: content });
    return { textId, content };
  }

  return {
    texts,
    formId: castedOld?.form_id,
    formName: castedOld?.form_data?.formName,
    formPostSubmit: {
      submitType: FormPostSubmitType.Message,
      successMessage: injectAndExtractTexts(
        castedOld?.form_data?.success_message
      ),
      failureMessage: injectAndExtractTexts(""),
    },
    notifications: { emails: [castedOld?.send_to] },
    formButton: {
      id: `Button:${nanoid()}`,
      action: { type: ButtonActionType.Submit },
      ...injectAndExtractTexts(castedOld?.form_data?.action?.label),
    },
    fields: castedOld?.form_data?.fields?.map?.((f) => ({
      id: `Field:${nanoid()}`,
      type: FIELDS_TYPES_MAPPER[f?.type] || FieldType.Text,
      settings: {
        placeholder: injectAndExtractTexts(f?.label),
        label: injectAndExtractTexts(""),
        description: injectAndExtractTexts(""),
        errorMessage: injectAndExtractTexts(""),
        required: !!f?.required,
        autoComplete: f?.name as any,
      },
    })),
  };
}

function injectIds(
  id: string | undefined,
  formId: string | undefined,
  settings: FormSettingsExtended
) {
  settings.formId = formId || settings.formId;
  return { ...settings, id };
}

export function migrateElement(
  id: string | undefined,
  old: OldFormValue | FormSettingsExtended
): SectionElement & { settings: FormSettingsExtended } {
  const settingsX = migrateSettings(old);
  const settings = injectIds(id, (old as OldFormValue).form_id, settingsX);

  return { id: id!, type: "Form", settings };
}
